import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { roiCalculatorStyles } from "../../../../../ThemeProvider";
import { StageType } from "../../../../../../graphql/types";
import { RoiFormData } from "../../../../helpers/roiStageData";
import PriceAtFarmGateFields from "../PriceAtFarmGateFields";

interface FarmGateSectionProps {
  formData: RoiFormData;
  readOnly: boolean;
}

const FarmGateSection: FC<FarmGateSectionProps> = ({ formData, readOnly }) => {
  const intl = useIntl();
  const roiClasses = roiCalculatorStyles();

  const stages = formData.feedBearingStages;
  const disabled = readOnly || formData.farmGate.disabled;

  const stageNameOf = (stageType: string | null) =>
    stages.find((s) => s.stageType === stageType)?.stageName;

  const renderFields = () => {
    if (formData.hasProcessingStage) {
      return (
        <PriceAtFarmGateFields
          fieldPrefix="farmGate"
          stageType={StageType.Processing}
          stageName={formData.processingStageName ?? ""}
          disabled={disabled}
          species={formData.species}
          processingOutputs={formData.processingOutputs}
        />
      );
    }

    if (formData.terminalOutputStageType) {
      return (
        <PriceAtFarmGateFields
          fieldPrefix="farmGate"
          stageType={formData.terminalOutputStageType as StageType}
          stageName={
            stageNameOf(formData.terminalOutputStageType) ??
            formData.terminalOutputStageType
          }
          disabled={disabled}
          species={formData.species}
          farmGatePrices={formData.farmGatePrices}
        />
      );
    }

    if (stages.some((s) => s.stageType === StageType.Breeding)) {
      return (
        <PriceAtFarmGateFields
          fieldPrefix="farmGate"
          stageType={StageType.Breeding}
          stageName={stageNameOf(StageType.Breeding) ?? ""}
          disabled={disabled}
          species={formData.species}
          farmGatePrices={formData.farmGatePrices}
        />
      );
    }

    return null;
  };

  return (
    <Box className={roiClasses.sectionColumn}>
      <Typography variant="h6" className={roiClasses.sectionTitle}>
        {intl.formatMessage({ id: "SUSTELL.ROI.FARM_GATE.TITLE" })}
      </Typography>

      {renderFields()}
    </Box>
  );
};

export default FarmGateSection;
